import {useMemo} from "react";
import {useAuth} from "react-oidc-context";
import {extractRolesFromProfile, rechteAusRolle} from "./authorization";
import {useFirebaseIdentitaet} from "./FirebaseIdentitaet";

const useAuthorization = () => {
  const auth = useAuth();
  const {rolle} = useFirebaseIdentitaet();

  return useMemo(
    () => ({
      ...rechteAusRolle(rolle),
      // Nur für Zusatzfunktionen ohne Zugriffsrecht, nie für Rechte.
      zitadelRollen: extractRolesFromProfile(auth.user?.profile),
      isAuthenticated: auth.isAuthenticated,
      user: auth.user,
    }),
    [rolle, auth.user, auth.isAuthenticated],
  );
};

export default useAuthorization;
